import { Button, Col, Modal, notification, Row, Space } from "antd"
import React, { useEffect, useRef, useState } from "react"
import styles from "../maintenance.module.css"
import { ReportModal } from "./ReportModal"
import { ApplicationRecord } from "./ApplicationRecord"
import ShenHe from "../assets/shenhe.png"
import {
  selectAppToken,
  selectCredentials,
  selectShortName,
  selectTenantAddress,
  selectTenantCityCode,
  selectUserName,
} from "../../../app/applicationSlice"
import { useDispatch, useSelector } from "react-redux"
import axios from "axios"
import { getAddress } from "../../treatment/editor/recipeEditorSlice"
import { RootDispatch } from "../../../app/store"
import { unwrapResult } from "@reduxjs/toolkit"
import { use } from "echarts/types/src/extension"
import { getDetailSimple } from "../../print/printSlice"
import { getSettingDetail, selectTenant } from "../../user/setting/settingSlice"
import {
  getAntibacterialStateName,
  getChildItem,
  getInstitutionalLevelName,
  getOperateStatusName,
  getOperateTypeName,
  getOwnershipTypeName,
  getServiceName,
  getSJWHTokenAsync,
} from "./data"
import { ExclamationCircleFilled } from "@ant-design/icons"
import { set } from "lodash"

export const OrganizationMaintenance = () => {
  // const token = useSelector(selectAppToken)

  const [token, setToken] = useState('')

  const tenant: any = useSelector(selectTenant)

  const credentials: any = useSelector(selectCredentials)

  const cityCode = useSelector(selectTenantCityCode)

  const AXIOS_IP = window.location.origin +  `/supervise_proxy/${cityCode == '320200' ? 'wuxi' : 'jiangsu'}/admin-api`

  // const AXIOS_IP = cityCode == '320200' ? "http://180.101.184.199:1001/wuxi/admin-api" : window.location.origin +  "/supervise_proxy/jiangsu/admin-api"

  // const AXIOS_IP = "http://153.37.232.237:9200/jiangsu/admin-api"

  const dispatch = useDispatch<RootDispatch>()

  const [visible, setVisible] = useState(false)

  const [changeVisible, setChangeVisible] = useState(false)

  const [isVisible, setIsVisible] = useState(false)

  const [recordVisible, setRecordVisible] = useState(false)

  const [type, setType] = useState(2)

  const [reportData, setReportData] = useState<any>()

  const [recordData, setRecordData] = useState<any>()

  const [detail, setDetail] = useState<any>()

  const [changeData, setChangeData] = useState<any>()

  const [reportLoading, setReportLoading] = useState(false)

  const [delay, setDelay] = useState(false)

  const getData = () => {
    dispatch(getSJWHTokenAsync())
    .then(unwrapResult)
    .then((token: any) => {
      setToken(token)
      axios({
      url: `${AXIOS_IP}/apply/queryInstitution`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "GET",
    })
      .then((v) => {
        if(v.data.code == 401) {
          setDelay(true)
          notification.error({
            message: "正在获取数据，请稍后再试。",
          })
          return
        } else {
          setDelay(false)
        }
        if (v.data.data?.id) {
          axios({
            url: `${AXIOS_IP}/apply/checkInstitution`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": token,
            },
            withCredentials: false,
            method: "GET",
          }).then((m) => {
            setVisible(true)
            setDetail({
              ...v.data.data,
              state: m ? 1 : 0,
              unitCategory: v.data.data?.type,
              chargePerson: v.data.data?.principal,
            })
          })
        } else {
          axios({
            url: `${AXIOS_IP}/apply/queryTenantApply`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": token,
            },
            withCredentials: false,
            method: "GET",
          })
            .then((res: any) => {
              if (res.data.data?.id) {
                setVisible(true)
                setDetail(res.data.data)
              }
            })
            .catch(() => {
              setVisible(false)
            })
        }
      })
      .catch((v) => {
        setVisible(false)
      })
    })
  }

  useEffect(() => {
    dispatch(getSettingDetail())
  }, [])

  useEffect(() => {
    getData()
  }, [])

  return (
    <Col className={styles.saveform}>
      <div>
        <Row justify="space-between">
          <Col style={{ fontSize: "17px", fontWeight: "bold" }}>
            卫健委平台机构信息
          </Col>
          <Col>
            <Space>
              <Button
                type="link"
                onClick={() => {
                  axios({
                    url: `${AXIOS_IP}/apply/queryApplicationRecords`,
                    headers: {
                      "Content-Type": "application/json",
                      "His-Auth": token,
                    },
                    withCredentials: false,
                    method: "GET",
                  }).then((res: any) => {
                    setRecordData(res.data.data)
                    setRecordVisible(true)
                  })
                }}
              >
                申请记录
              </Button>
              {visible && (
                <Button
                  type="primary"
                  onClick={() => {
                    axios({
                      url: `${AXIOS_IP}/apply/queryApprovalRecords`,
                      headers: {
                        "Content-Type": "application/json",
                        "His-Auth": token,
                      },
                      withCredentials: false,
                      method: "POST",
                    }).then((v) => {
                      // if(v.data.data) {
                        axios({
                          url: `${AXIOS_IP}/apply/queryRecentTenantApply`,
                          headers: {
                            "Content-Type": "application/json",
                            "His-Auth": token,
                          },
                          withCredentials: false,
                          method: "POST",
                        }).then((m) => {
                          setReportData({ 
                            ...m.data.data, 
                            unitCategory: Number(m.data.data?.unitCategory),
                            regioncode: Number(m.data.data?.regioncode)
                          })
                          setChangeData(v.data.data ? { ...m.data.data } : undefined)
                          setType(2)
                          setIsVisible(true)
                        })
                      // }
                    })
                  }}
                >
                  申请调整
                </Button>
              )}
            </Space>
          </Col>
        </Row>
        {!visible ? (
          <div className={styles.uploadBtn}>
            <p style={{ marginBottom: "37px" }}>
              卫健委平台找不到该机构的信息，请先上报机构信息
            </p>
            <Button
              type="primary"
              onClick={() => {
                axios({
                  url: `${AXIOS_IP}/apply/queryInstitution`,
                  headers: {
                    "Content-Type": "application/json",
                    "His-Auth": token,
                  },
                  withCredentials: false,
                  method: "GET",
                }).then((v) => { 
                  if(v.data.code == 401 || v.data.data) {
                    getData()
                  } else {
                    setReportData({
                      name: tenant?.shortName,
                      address: tenant?.address,
                      phone: tenant?.tenantPhone,
                      // uniCode: tenant?.organCode,
                      // unitCategory: Number(tenant?.tenantCategory) - 1,
                      legalRepresentative: tenant?.legalPerson,
                      postalCode: tenant?.postCode,
                      regioncode: Number(tenant?.countyCode + '000000'),
                      institutionalLevel: Number(tenant?.medicalOrganLevel) - 1
                    })
                    setType(1)
                    setIsVisible(true)
                  }
                })
              }}
            >
              上报机构信息
            </Button>
          </div>
        ) : (
          <Col style={{ marginTop: 18, position: "relative" }}>
            {detail?.state == 0 ? (
              <img
                src={ShenHe}
                alt=""
                style={{
                  width: "95px",
                  height: "95px",
                  position: "absolute",
                  top: 10,
                  right: 50,
                }}
              />
            ) : (
              <></>
            )}
            <Row className={styles.formRow}>
              <Col span={24}>
                <Row>
                  <Col span={4} className={styles.leftCol}>
                    机构名称：
                  </Col>
                  <Col
                    span={20}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {detail?.name}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={24}>
                <Row>
                  <Col span={4} className={styles.leftCol}>
                    机构第二名称：
                  </Col>
                  <Col
                    span={20}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {detail?.secondName}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    社会统一信用代码：
                  </Col>
                  <Col span={16} className={styles.rightCol}>
                    {detail?.uniCode}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    营业状态：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {getOperateStatusName(detail?.operateStatus)}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    医院级别：
                  </Col>
                  <Col span={16} className={styles.rightCol}>
                    {getInstitutionalLevelName(detail?.institutionalLevel)}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    单位类别：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {getChildItem(detail?.unitCategory)}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    经营性质：
                  </Col>
                  <Col span={16} className={styles.rightCol}>
                    {getOperateTypeName(detail?.operateType)}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    所有制形式：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {getOwnershipTypeName(detail?.ownershipType)}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    有效开始日期：
                  </Col>
                  <Col span={16} className={styles.rightCol}>
                    {detail?.effectStartDate}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    有效结束日期：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {detail?.effectEndDate}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    下一个校验日期：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                  >
                    {detail?.nextCheckTime}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    床位数：
                  </Col>
                  <Col span={16} className={styles.rightCol} style={{ borderRight: "none" }}>
                    {detail?.bedAmount}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    牙科诊椅数：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                  >
                    {detail?.dentalChairAmount}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    法定代表人：
                  </Col>
                  <Col span={16} className={styles.rightCol} style={{ borderRight: "none" }}>
                    {detail?.legalRepresentative}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    法人证件号：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                  >
                    {detail?.corporationNumber}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    邮编：
                  </Col>
                  <Col span={16} className={styles.rightCol} style={{ borderRight: "none" }}>
                    {detail?.postalCode}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    主要负责人：
                  </Col>
                  <Col span={16} className={styles.rightCol}>
                    {detail?.chargePerson}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    负责人证件号：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {detail?.chargePersonNumber}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    行政区划名称：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {detail?.area}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={24}>
                <Row>
                  <Col span={4} className={styles.leftCol}>
                    医疗机构地址：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {detail?.address}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={24}>
                <Row>
                  <Col span={4} className={styles.leftCol}>
                    诊疗科目名称：
                  </Col>
                  <Col span={20} className={styles.rightCol} style={{ borderRight: "none" }}>
                    {detail?.diagnosisSubject}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    抗菌药品静脉输注权限：
                  </Col>
                  <Col span={16} className={styles.rightCol}>
                    {getAntibacterialStateName(detail?.antibacterialState)}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    电话：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {detail?.phone}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    发证机关：
                  </Col>
                  <Col span={16} className={styles.rightCol}>
                    {detail?.licenceIssuingAuthority}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    批准文号：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {detail?.approvalNumber}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row
              className={styles.formRow}
              style={{ borderBottom: "1px solid #eef4ff" }}
            >
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    注册资金：
                  </Col>
                  <Col span={16} className={styles.rightCol}>
                    {detail?.registeredCapital}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8} className={styles.leftCol}>
                    服务方式：
                  </Col>
                  <Col
                    span={16}
                    className={styles.rightCol}
                    style={{ borderRight: "none" }}
                  >
                    {getServiceName(detail?.service)}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        )}
      </div>

      <ReportModal
        visible={isVisible}
        data={reportData}
        type={type}
        reportLoading={reportLoading}
        onCancel={() => setIsVisible(false)}
        onOk={(data) => {
          setReportLoading(true)
          axios({
            url:
              type == 1
                ? `${AXIOS_IP}/apply/reportInstitution`
                : (type == 2 || type == 3) && changeData?.id
                ? `${AXIOS_IP}/apply/updateExamineRecordDetail`
                : `${AXIOS_IP}/apply/applyChangeRecord`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": token,
            },
            withCredentials: false,
            method: "POST",
            data: {
              ...data,
              applyUser: credentials?.name,
              createUser: credentials?.phone,
              updateUser: credentials?.phone,
              askType: type == 1 || type == 3 ? 2 : 1, //信息调整1 上报 2,
              id: changeData?.id ? changeData?.id : undefined,
            },
          })
            .then((res) => {
              notification.success({
                message: "操作成功",
              })
              setIsVisible(false)
              // if (type == 1) {
              //   axios({
              //     url: `${AXIOS_IP}/apply/queryTenantApply`,
              //     headers: {
              //       "Content-Type": "application/json",
              //       "His-Auth": token,
              //     },
              //     withCredentials: false,
              //     method: "GET",
              //   }).then((res) => {
              //     setVisible(true)
              //     setDetail(res.data.data)
              //   })
              // }
              getData()
            })
            .finally(() => {
              setChangeData(undefined)
              setReportLoading(false)
            })
        }}
      />

      <ApplicationRecord
        visible={recordVisible}
        data={recordData}
        type={1}
        onWithdraw={(v: any) => {
          Modal.confirm({
            centered: true,
            title: "确认操作",
            content: (
              <div>
                <ExclamationCircleFilled
                  style={{ color: "#FFAE55", fontSize: 18 }}
                />
                &nbsp;是否确认撤回？
              </div>
            ),
            okText: "确认",
            cancelText: "取消",
            icon: null,
            onOk: () => {
              axios({
                url: `${AXIOS_IP}/apply/updateExamineRecordDetail`,
                headers: {
                  "Content-Type": "application/json",
                  "His-Auth": token,
                },
                withCredentials: false,
                method: "POST",
                data: {
                  id: v?.id,
                  state: 2,
                },
              }).then(() => {
                notification.success({
                  message: "操作成功",
                })
                axios({
                  url: `${AXIOS_IP}/apply/queryApplicationRecords`,
                  headers: {
                    "Content-Type": "application/json",
                    "His-Auth": token,
                  },
                  withCredentials: false,
                  method: "GET",
                }).then((res: any) => {
                  setRecordData(res.data.data)
                })
              })
            },
          })
        }}
        onChange={(v) => {
          axios({
            url: `${AXIOS_IP}/apply/queryRecentTenantApply`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": token,
            },
            withCredentials: false,
            method: "POST",
          }).then((res: any) => { 
            setChangeData(v)
            setReportData({ ...res.data.data })
            setType(v.askType == 1 ? 2 : 3)
            setRecordVisible(false)
            setIsVisible(true)
          })
        }}
        onCancel={() => setRecordVisible(false)}
      />
    </Col>
  )
}
